import { z } from '@repo/schema'
import { getDataWrapperSchema } from '@repo/schema/data-wrapper'
import { GetPaginationSchema } from '@repo/schema/pagination'
import { CreateReportBodySchema, GetReportSchema } from '@repo/schema/reports'
import { GetUserSchema } from '@repo/schema/user'
import { UpFetch } from '@repo/upfetch'

import { createProcedure } from '../../lib/procedure'

const ReportSchema = GetReportSchema.extend({ generated_by: GetUserSchema.nullish() })

export const createReportsRoute = (upFetch: UpFetch) => {
  const p = createProcedure(upFetch)

  const sortDirectionSchema = z.enum(['asc', 'desc'])
  const listInputSchema = z
    .object({
      'filter[created_at]': z.string().optional(),
      'filter[generated_at]': z.string().optional(),
      'filter[generated_by]': z.string().optional(),
      'filter[status]': z.string().optional(),
      'filter[type]': z.string().optional(),
      page: z.number().optional(),
      perPage: z.number().optional(),
      'sort[created_at]': sortDirectionSchema.optional(),
      'sort[date_from]': sortDirectionSchema.optional(),
      'sort[date_to]': sortDirectionSchema.optional(),
      'sort[generated_at]': sortDirectionSchema.optional(),
      'sort[id]': sortDirectionSchema.optional(),
      'sort[status]': sortDirectionSchema.optional(),
      'sort[type]': sortDirectionSchema.optional(),
    })
    .optional()

  return {
    commission: {
      download: p
        .path(z.object({ id: z.number() }), p => ['commissions', 'reports', p.id, 'download'])
        .query(({ path, upFetch }) =>
          upFetch(path, { parseResponse: response => response.blob() }),
        ),

      generate: p
        .path('commissions', 'reports')
        .input(CreateReportBodySchema)
        .mutation(({ input, path, upFetch }) =>
          upFetch(path, {
            body: input,
            method: 'POST',
            schema: getDataWrapperSchema(ReportSchema),
          }),
        ),
    },

    list: p
      .path('reports')
      .input(listInputSchema)
      .query(({ input, path, upFetch }) =>
        upFetch(path, { params: input, schema: GetPaginationSchema(ReportSchema) }),
      ),

    loadsData: {
      download: p
        .path(z.object({ id: z.number() }), p => ['loads', 'reports', p.id, 'download'])
        .query(({ path, upFetch }) => upFetch(path, { schema: z.object({ url: z.string() }) })),

      generate: p
        .path('loads', 'reports')
        .input(CreateReportBodySchema)
        .mutation(({ input, path, upFetch }) =>
          upFetch(path, {
            body: input,
            method: 'POST',
            schema: getDataWrapperSchema(ReportSchema),
          }),
        ),
    },
  }
}
